const filterInitiativesByImpactUpdate2025 = (initiatives, currentDate) => {
  const impactGroups = {
    '<not set>': [],
    'No actuals (below L3 or cancelled/on hold)': [],
    'No actuals required or no impacts': [],
    'Missing actual in last completed month': [],
    'Missing actual in previous months': [],
    'Missing actual in last completed and previous completed months': [],
    'Filled actual (last completed month required only)': [],
    'Filled actual (previous months required only)': [],
    'Filled actual (last completed and previous months required)': [],
  };

  const calculateMonthIndex = (balanceDate) => {
    const startYear = 2023; // Fiscal year starts from July 2023
    const startMonth = 6; // July is the 6th month (0-based index)

    const date = new Date(balanceDate); // Convert the BalanceDate string to a Date object
    const year = date.getFullYear();
    const month = date.getMonth(); // JavaScript months are 0-based (Jan = 0, ..., Dec = 11)

    // Calculate the month index relative to July 2023
    const monthIndex = (year - startYear) * 12 + (month - startMonth);

    return monthIndex;
  };

  const currentMonthIndex = calculateMonthIndex(currentDate);

  initiatives.forEach((initiative) => {
    const impacts = initiative.impact || [];

    if (impacts.length === 0) {
      impactGroups['<not set>'].push(initiative);
      return;
    }

    const lastCompletedMonthIndex = currentMonthIndex - 1;
    const previousCompletedMonthIndices = [];
    for (let i = currentMonthIndex - 2; i >= 0; i--) {
      previousCompletedMonthIndices.push(i);
    }

    const hasLastCompletedMonthActual = impacts.some((impact) => {
      return (
        impact.monthlyActual &&
        impact.monthlyActual[lastCompletedMonthIndex] &&
        impact.monthlyActual[lastCompletedMonthIndex] !== undefined &&
        impact.monthlyActual[lastCompletedMonthIndex] !== null
      );
    });

    const hasPreviousCompletedMonthActual = impacts.some((impact) => {
      return previousCompletedMonthIndices.some((previousIndex) => {
        return (
          impact.monthlyActual &&
          impact.monthlyActual[previousIndex] &&
          impact.monthlyActual[previousIndex] !== undefined &&
          impact.monthlyActual[previousIndex] !== null
        );
      });
    });

    const isBelowL3OrCancelledOrOnHold =
      initiative.stage && ['L0', 'L1', 'L2'].includes(initiative.stage);
    const isCancelledOrOnHold =
      initiative.weeklyStatus && ['Cancelled', 'On hold'].includes(initiative.weeklyStatus);

    if (isBelowL3OrCancelledOrOnHold || isCancelledOrOnHold) {
      impactGroups['No actuals (below L3 or cancelled/on hold)'].push(initiative);
    } else if (
      impacts.every(
        (impact) =>
          !impact.monthlyActual ||
          impact.monthlyActual.length === 0 ||
          impact.monthlyActual.every((actual) => actual === undefined || actual === null)
      )
    ) {
      impactGroups['No actuals required or no impacts'].push(initiative);
    } else if (!hasLastCompletedMonthActual && !hasPreviousCompletedMonthActual) {
      impactGroups['Missing actual in last completed and previous completed months'].push(
        initiative
      );
    } else if (!hasLastCompletedMonthActual) {
      impactGroups['Missing actual in last completed month'].push(initiative);
    } else if (!hasPreviousCompletedMonthActual) {
      impactGroups['Missing actual in previous months'].push(initiative);
    } else if (hasLastCompletedMonthActual && hasPreviousCompletedMonthActual) {
      impactGroups['Filled actual (last completed and previous months required)'].push(initiative);
    } else if (hasLastCompletedMonthActual) {
      impactGroups['Filled actual (last completed month required only)'].push(initiative);
    } else if (hasPreviousCompletedMonthActual) {
      impactGroups['Filled actual (previous months required only)'].push(initiative);
    } else {
      impactGroups['<not set>'].push(initiative);
    }
  });

  return impactGroups;
};

export default filterInitiativesByImpactUpdate2025;
